export default __webpack_public_path__ + "static/media/chapterTest.e3c78f47.svg";